import {
  portal_login_simulate_confirm_get,
  portal_login_simulate_cancel_get
} from 'server/modules/720.js'
import { message } from 'ant-design-vue'
import { onLoginSuccess } from '@/views/Login/hook'
import { useStore } from 'vuex'
export const useNavbar = state => {
  const store = useStore()
  const socketRequest = (url, callback) => {
    let socket = null
    // 建立连接
    const connect = () => {
      const socketUrl = process.env.VUE_APP_WS_PROTAL + url
      socket = new WebSocket(socketUrl)
      socket.onopen = () => {
        console.log('连接成功')
        sendMessage()
      }
      socket.onmessage = event => {
        console.log(event, 'event')
        const data = JSON.parse(event.data)
        if (data.retCode * 1 === 5000002) {
          message.success(data.retInfo)
          callback && callback(true)
        } else if (data.retCode * 1 === 5000008) {
          // 5000008正在等待中不做处理
          console.log(data.retInfo)
        } else {
          message.error(data.retInfo)
          callback && callback(false)
        }
      }
      socket.onerror = error => {
        console.error('连接错误:', error)
        reconnect()
      }

      socket.onclose = event => {
        console.log('连接已关闭', event)
        if (event.code === 1000) {
          console.log('正常关闭')
        } else {
          console.log('异常关闭')
          //   reconnect()
        }
      }
    }
    // 发送消息
    const sendMessage = () => {
      if (!socket || socket.readyState !== WebSocket.OPEN) {
        return console.log('连接未就绪')
      }
      const message = {
        type: 'message',
        content: 'Hello Server!',
        timestamp: Date.now()
      }
      try {
        socket.send(JSON.stringify(message))
        console.log('已发送: ' + JSON.stringify(message))
      } catch (error) {
        console.log('发送失败: ' + error.message)
      }
    }
    const closeConnection = () => {
      if (socket) {
        socket.close(1000, '用户主动关闭') // 1000 表示正常关闭
      }
    }
    // 重连机制（带指数退避）
    const reconnect = (attempt = 1) => {
      const maxAttempts = 5
      if (attempt > maxAttempts) return console.log('重连失败')

      const delay = Math.min(1000 * Math.pow(2, attempt), 30000)
      console.log(`将在 ${delay}ms 后重试 (${attempt}/${maxAttempts})`)

      setTimeout(() => {
        console.log('尝试重连...')
        connect()
        attempt++
      }, delay)
    }
    return {
      connect,
      sendMessage,
      closeConnection,
      reconnect
    }
  }
  const handleSimulate = async () => {
    state.isPending = true
    const token = localStorage.getItem('token') || null
    const { connect } = socketRequest(
      `/portal/websocket/simulation?userId=${state.simulateUser}&Authorization=${token}`,
      flag => {
        if (flag) {
          simulationLogin()
        } else {
          state.isPending = false
          state.showSimulate = false
          state.simulateUser = null
        }
      }
    )
    connect()
  }
  //   模拟登陆
  const simulationLogin = async () => {
    state.isPending = false
    const { success, retInfo, data } = await portal_login_simulate_confirm_get({
      userId: state.simulateUser
    })
    if (success) {
      localStorage.setItem('isVirtual', data.virtual)
      onLoginSuccess(data, store)
    } else {
      message.error(retInfo)
    }
  }
  //   退出模拟登陆
  const simulationLogout = async () => {
    const { success, retInfo, data } = await portal_login_simulate_cancel_get(
      {}
    )
    if (success) {
      message.success(retInfo)
      if (data) {
        localStorage.setItem('isVirtual', data.virtual)
        onLoginSuccess(data, store)
      }
    } else {
      message.error(retInfo)
    }
  }
  return {
    socketRequest,
    handleSimulate,
    simulationLogout
  }
}
